export default {
  field: {
    location_1: "苗栗獅潭",
    name_1: "紙湖農場",
    address_1: "354苗栗縣獅潭鄉苗栗縣獅潭鄉百壽村18號",

    location_2: "桃園龍潭",
    name_2: "桃園客家文化館",
    address_2: "325桃園市龍潭區中正路三林段500號",

    location_3: "新竹峨眉",
    name_3: "歇心茶樓",
    address_3: "315新竹縣峨眉鄉60-8",

    location_4: "新竹峨眉",
    name_4: "十二寮休閒農業園區",
    address_4: "315新竹縣峨眉鄉13鄰21號",

    location_5: "苗栗公館",
    name_5: "油桐花坊",
    address_5: "363苗栗縣公館鄉福德村打鹿坑福德35之3號",

    location_6: "苗栗三義",
    name_6: "卓也小屋",
    address_6: "367苗栗縣三義鄉雙潭村崩山下1-9號",

    location_7: "臺中東勢",
    name_7: "東勢客家文化園區",
    address_7: "423臺中市東勢區中山路1號",

    location_8: "彰化芬園",
    name_8: "古生物奇幻樂園",
    address_8: "502彰化縣芬園鄉中山路167號",

    location_9: "南投埔里",
    name_9: "牛耳藝術渡假村",
    address_9: "545南投縣埔里鎮中山路四段1號",

    location_10: "苗栗銅鑼",
    name_10: "桐花樂活公園",
    address_10: "366苗栗縣銅鑼鄉龍泉15號",

    location_11: "新竹新埔",
    name_11: "新埔森Villa",
    address_11: "305新竹縣新埔鎮新龍路752巷38號",

    location_12: "苗栗頭屋",
    name_12: "魯冰花休閒農莊",
    address_12: "362苗栗縣頭屋鄉明德村仁隆21號",

    location_13: "苗栗通霄",
    name_13: "上田咖啡休閒莊園",
    address_13: "35750苗栗縣通霄鎮九鄰93-1號",

    location_14: "新竹關西",
    name_14: "馬武督探索森林",
    address_14: "306新竹縣關西鎮12鄰138-3號",

    location_15: "臺東鹿野",
    name_15: "舊鐵道桐花步道",
    address_15: "",

    location_16: "苗栗銅鑼",
    name_16: "臺灣客家文化館",
    address_16: "366003苗栗縣銅鑼鄉銅科南路6號",

    location_17: "苗栗造橋",
    name_17: "劍潭古道",
    address_17: "",

    location_18: "嘉義市",
    name_18: "幸福山丘",
    address_18: "600嘉義市東區東義路566巷52-1號",

    location_19: "花蓮吉安",
    name_19: "南華林業園區",
    address_19: "973花蓮縣吉安鄉吉安路六段117號",

    location_20: "新竹橫山",
    name_20: "大山北月",
    address_20: "312新竹縣橫山鄉大山背80號"
  },

  menu: {
    language: "語言",
    flowering_map: "開花地圖",
    main_platform_name: "客庄小旅行",
    header_platform_name: "{year_tw}年桐花花況預測",
    platform_name: "桐花花況預測平台",
    // banner_description: "{year_tw}年桐花花況最新資訊 & 花期預測 ({year_tw}年4月1日起更新花況推估)",
    banner_description: "{year_tw}年桐花花況 & 花期預測 (花期已結束)",
    go_to_top: "TOP",

    north: "北部地區",
    central: "中部地區",
    south: "南部地區",
    east: "東部地區",

    stage_bud: "花苞",
    stage_flowering: "開花",
    stage_blossoming: "盛開",
    stage_wither: "花期尾聲",
    map_of_taiwan: "臺灣地圖",
    data_source: "資料來源",
    CWB_stations: "中央氣象署",
    CWB_forecast: "中央氣象署一週天氣預報",
    forecast: "一周天氣",
    uv_info: "紫外線",
    realtime_data: "最新數據",
    updated_at: "更新時間",
    line_group: "賞花最新資訊 Line 群組",
    join_line_group_description: "加入 Line 群組以獲得最新賞花資訊",
    line_group_button_for_phone: "手機請按此加入",
    traffic: "交通資訊",
    info_description:
      "桐花花期預測依實地監測環境數據及歷史花況建立預測模型推估預測，並依實際氣候環境資料，滾動式更新花期資訊。",
    info_description2:
      "目前計有於桃園、新竹、苗栗、臺中、彰化、南投、嘉義、花蓮及臺東等9縣市建置20處監測設備",
    info_update: "更新時間",
    info_source:
      '資訊由<a href="https://www.hakka.gov.tw" target="blank">客家委員會</a>、<a href="https://www.agriweather.online" target="blank">阿龜微氣候</a>合作開發提供',
    recommand_link:
      '好站連結：<a href="https://www.cwa.gov.tw/V8/C/L/Hakka/index.html" target="blank">中央氣象署</a>、<a href="https://recreation.forest.gov.tw" target="blank">臺灣山林悠遊網</a>'
  },

  sensor: {
    air_temperature: "空氣溫度",
    u_air_temperature: "℃",
    air_humidity: "空氣溼度",
    u_air_humidity: "%",

    rainfalls: "累積雨量",
    u_rainfalls: "mm",
    rain_rate: "降雨速率",
    u_rain_rate: "mm/hr",
    wind_speed: "風速",
    u_wind_speed: "m/s",
    solar_radiation: "光照",
    u_solar_radiation: "W/m<sup>2</sup>"
  }
};
